import { useCallback, useRef, useState, useEffect } from 'react';

import { getAddress, sortByCreated, getFullName } from 'utils';
import { FILTER_BY_ADDRESS, FILTER_BY_USER, FILTER_BY_FILE } from 'constants/orders';

const useOrders = (orders) => {
  const [ordersList, setOrders] = useState(orders);
  const filterStatus = useRef(false);
  const filterQuery = useRef('');
  const filterQueryBy = useRef(FILTER_BY_ADDRESS);

  const setStatusFilter = (status) => {
    filterStatus.current = status;
  };

  const setQuery = (query) => {
    filterQuery.current = query;
  };

  const setQueryBy = (filterBy) => {
    filterQueryBy.current = filterBy;
  };

  const filterOrders = useCallback(() => {
    var visibleOrders = orders;

    if (filterStatus.current) {
      visibleOrders = visibleOrders.filter(
        (order) => order.status === filterStatus.current
      );
    }

    if (filterQuery.current) {
      visibleOrders = visibleOrders.filter((order) => {
        switch (filterQueryBy.current) {
          case FILTER_BY_FILE:
            return (order.file_number || '')
              .toLowerCase()
              .includes(filterQuery.current.toLowerCase());
          case FILTER_BY_USER:
            return !!~getFullName(order.user)
              .toLowerCase()
              .indexOf(filterQuery.current.toLowerCase());
          default:
            return getAddress(order)
              .toLowerCase()
              .includes(filterQuery.current.toLowerCase());
        }
      });
    }

    setOrders(visibleOrders);
  }, [orders]);

  const handleSetStatus = (status) => {
    setStatusFilter(status);
    filterOrders();
  };

  const handleSearchBy = (filterBy) => {
    setQueryBy(filterBy);
    filterOrders();
  };

  const handleSearchOrder = (query) => {
    setQuery(query);
    filterOrders();
  };

  useEffect(() => {
    filterOrders();
  }, [filterOrders, orders]);

  return {
    handleSearchBy: handleSearchBy,
    handleStatusFilter: handleSetStatus,
    handleSearch: handleSearchOrder,
    orders: sortByCreated(ordersList),
    activeQueryBy: filterQueryBy.current,
    activeQuery: filterQuery.current || '',
    activeFilter: filterStatus.current
  };
};

export default useOrders;
